module.exports = __webpack_public_path__ + "static/media/logo-klook.71160a5b.png";